import { render } from "./RegisterInterest.vue?vue&type=template&id=ca13d648&scoped=true&ts=true"
import script from "./RegisterInterest.vue?vue&type=script&lang=ts"
export * from "./RegisterInterest.vue?vue&type=script&lang=ts"

import "./RegisterInterest.vue?vue&type=style&index=0&id=ca13d648&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.2.47_vue@3.2.47_webpack@5.90.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca13d648"]])

export default __exports__